//
//
//

export default {
    name: "topicHot",
    data(){
        return {
            map:null,
            // latlog:{
            //     lat: 40.028016424583,
            //     lng: 116.47563481273
            // }
            latlog:{
                lat: '',
                lng: ''
            }
        }
    },
    props: {
        hostPonit:{ // 是否展示选择按钮
            type: Object,
            default() { return {}; }
        }
    },
    created() {
        this.latlog.lng =  this.hostPonit.lng ? this.hostPonit.lng : this.$route.query.lng;
        this.latlog.lat = this.hostPonit.lat ? this.hostPonit.lat : this.$route.query.lat;
    },
    mounted(){
        this.map = new BMap.Map("container"); 
        this.mapShow(this.latlog.lng,this.latlog.lat)   

    },
    methods:{
        mapCLick(e){
            this.mapShow(e.lng,e.lat)
        },
        mapShow(lng,lat){
            //console.log(lng,lat)
            var pt = new BMap.Point(lng,lat);
            this.map.centerAndZoom(pt, 15); 
            var myIcon = new BMap.Icon("https://static.soyoung.com/sy-pre/position-1577082637010.png", new BMap.Size(80,80));
            var marker2 = new BMap.Marker(pt,{icon:myIcon});  // 创建标注
            this.map.addOverlay(marker2);  
            this.map.setCenter(lng,lat)
        }
    }
}
